import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shell-component',
  templateUrl: './shell-component.component.html',
  styleUrls: ['./shell-component.component.css']
})
export class ShellComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
